import React from "react";
import { LanguagesMenu } from "../../../../components/LanguageSwitcher/loader";
import MenuSection from "../../../../components/Menu/MenuSection";
import { UserContextSelectors } from "../../../../redux/selectors";
import { useSelector } from "react-redux";
import { LocalizationMessages } from "../../../../localization/messages";
import { UserareaSectionContainerItem } from "../../../../components/common/UserareaSectionContainerItem";
import { useCommunicationHandlers } from "../../../UsefulLinks";

const SecondaryMenuLayout = () => {
  const isMobile = useSelector(UserContextSelectors.isMobile);
  const { handleHelpCenter } = useCommunicationHandlers();

  const linksProps = [
    {
      onClick: handleHelpCenter,
      text: LocalizationMessages.helpCenter,
      name: "Useful Links_Poker SupportInformation",
      hasIcon: true,
      iconKey: "question-mark"
    }
  ];

  const Items = linksProps.map((linkProps, index) => {
    return <UserareaSectionContainerItem key={index} linkProps={linkProps} />;
  });

  return (
    <>
      {isMobile && (
        <MenuSection className="menu-section">
          <LanguagesMenu />
          {Items}
        </MenuSection>
      )}
    </>
  );
};

export default React.memo(SecondaryMenuLayout);
